import React from 'react';

import { 
  Box,
  Typography
} from '@mui/material';

import MiscellaneousServicesOutlinedIcon from '@mui/icons-material/MiscellaneousServicesOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import FeedOutlinedIcon from '@mui/icons-material/FeedOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SyncAltIcon from '@mui/icons-material/SyncAlt';

import "../styles.scss";

const FusionWyzia = ({
  navigate,
  currentPage
}) => {
  return (
    <Box className="nav__side-common flex_SBColumn" 
      display={"flex"} flexDirectsion={"column"} gap={"10px"}>
      <Box className="nav__side-container">
        <Box className={`nav__side-item flexCenter_Row`}
          onClick={() => {
            navigate("/business/fusion");
          }}>
          <ArrowBackIcon />
          <Typography variant='body2'>
            Back
          </Typography>
        </Box>
        <Box className={`${currentPage === 0 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/fusion/wyzia");
          }}>
          <HomeOutlinedIcon />
          <Typography variant='body2'>
            Home Page
          </Typography>
        </Box>
        <Box className={`${currentPage === 1 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/fusion/wyzia/campaigns");
          }}>
          <BusinessOutlinedIcon />
          <Typography variant='body2'>
            Campaigns
          </Typography>
        </Box>
				<Box className={`${currentPage === 2 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/fusion/wyzia/deposits");
          }}>
          <PersonOutlinedIcon />
          <Typography variant='body2'>
            Deposits
          </Typography>
        </Box>
        <Box className={`${currentPage === 3 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/fusion/wyzia/withdrawals");
          }}>
          <SyncAltIcon />
          <Typography variant='body2'>
            Withdrawals
          </Typography>
        </Box>
        <Box className={`${currentPage === 4 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/fusion/wyzia/transactions");
          }}>
          <VerifiedOutlinedIcon />
          <Typography variant='body2'>
            Transactions
          </Typography>
        </Box>
        <Box className={`${currentPage === 5 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/fusion/wyzia/kyc");
          }}>
          <BadgeOutlinedIcon />
          <Typography variant='body2'>
            KYC
          </Typography>
        </Box>
        <Box className={`${currentPage === 6 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/fusion/wyzia/due-dilligence");
          }}>
          <FeedOutlinedIcon />
          <Typography variant='body2'>
            Due Dilligence
          </Typography>
        </Box>
        <Box className={`${currentPage === 7 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/fusion/wyzia/miscellaneous");
          }}>
          <MiscellaneousServicesOutlinedIcon />
          <Typography variant='body2'>
            Miscellaneous
          </Typography>
        </Box>
      </Box>
    </Box>  
  )
}

export default FusionWyzia;